<template>
  <v-layout
    column
    fill-height
    class="mb-3"
  >
    <v-card-title class="mb-0 pb-0" v-if="showButtons">
      <v-btn icon :to="getBackUrl" active-class="">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="can('edit teachers')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
             icon
             v-bind="attrs"
             v-on="on"
             @click="editTeacher"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('EDIT') }}</span>
      </v-tooltip>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="deleteTeacher">
              <v-icon>block</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('DELETE') }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-title class="mt-1 pt-0">
    </v-card-title>
    <v-tabs
      :value="currentTab"
      @change="tabChanged"
      centered
      grow
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab dark href="#teacher">
          {{ $t('TEACHER') }}
        </v-tab>
        <v-tab dark href="#school">
          {{ $t('SCHOOLS') }}
        </v-tab>
    </v-tabs>
  </v-layout>
</template>
<script>

  export default {
    name: 'TeacherTabs',
    props: {
      value: String,
      showButtons: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        currentTab: this.value,
      };
    },
    computed: {
      getBackUrl() {
        if (this.$route.query.returnUrl) {
          return { path: this.$route.query.returnUrl };
        }
          return { name: this.routeName.TEACHER };
      },
    },
    methods: {
      deleteTeacher() {
        this.$emit('delete');
      },

      editTeacher() {
        this.$emit('edit');
      },

      tabChanged(tab) {
        this.$emit('input', tab);
      },

    },
    watch: {
      '$route.query': {
        immediate: true,
        handler(val) {
          if (val.tab) {
            this.currentTab = val.tab;
            this.tabChanged(val.tab);
          }
        },
      },
    },
  };
</script>
